import { useSessionUser, useToken } from '@/store/authStore'
import { CONSENT_REQUIRED_KEY } from '@/constants/app.constant'
import type { AxiosError } from 'axios'

const unauthorizedCode = [401, 419, 440]

const AxiosResponseIntrceptorErrorCallback = (error: AxiosError) => {
    const { response } = error
    const { setToken } = useToken()

    if (response && unauthorizedCode.includes(response.status)) {
        setToken('')
        useSessionUser.getState().setUser({})
        useSessionUser.getState().setSessionSignedIn(false)
    }

    // Mirrors ConsentEnforcementFilter on the backend: any authenticated call
    // that comes back blocked pending mandatory consent gets flagged so the
    // next route change lands the employee on /consent, even if they reached
    // this page some other way than the post-login redirect.
    if (response?.status === 403 && response.headers?.['x-consent-required']) {
        sessionStorage.setItem(CONSENT_REQUIRED_KEY, '1')
    }
}

export default AxiosResponseIntrceptorErrorCallback
